import { useRouter } from 'hooks';
import { Box, Text, RouterLink, Paper, Grid, Link } from 'components/common';
import config from 'config';
import { Trans } from 'react-i18next';
import { LoginForm } from 'components/account/login-form';
// import maintenance from 'assets/images/maintenance.png?url';

export const Login = () => {
	const router = useRouter();

	return (
		<Grid container>
			<Grid item md={4} xl={4} sm={2} xs={0} />
			{/* <img
				src={maintenance}
				alt='maintenance'
				style={{ width: '100%' }}
			/> */}
			<Grid item md={4} xl={4} sm={8} xs={12}>
				<Box
					component={Paper}
					px={4.5}
					py={3}
					elevation={0}
					display='flex'
					flexDirection='column'
				>
					<LoginForm />
					<Box alignSelf='stretch'>
						<Box
							component='hr'
							border='none'
							borderTop='1px solid'
							borderColor={theme => theme.borderColors[0.1]}
							my={4}
							mx={2}
						/>
					</Box>
					<Box textAlign='center' color={theme => theme.blacks[0.54]}>
						<Text variant='body1'>
							<Trans
								i18nKey='login.no-account-message'
								components={{
									search: (
										<RouterLink
											to={router.getPathFor(
												'community.search'
											)}
										/>
									),
									create: (
										<RouterLink
											to={router.getPathFor(
												'community.create'
											)}
										/>
									),
								}}
							/>
						</Text>
						<Text variant='body1' mt={1}>
							<Trans
								i18nKey='login.having-trouble'
								components={{
									mail: (
										<Link
											href={`mailto:${config.supportEmail}`}
										/>
									),
								}}
							/>
						</Text>
					</Box>
				</Box>
			</Grid>
		</Grid>
	);
};
